import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './ticketSelector.messages';
import { Container, Title, Disclaimer } from './ticketsSelector.styles';
import { GroupRulesSummary } from './groupRulesSummary';
import { renderWhenNotNil, renderWhenTrue } from '../../../../shared/utils/rendering';
import { TicketsCounter } from './ticketsCounter';
import PriceSummary from './priceSummary/priceSummary.container';

export class TicketsSelector extends PureComponent {
  static propTypes = {
    experience: PropTypes.object,
    totalPrice: PropTypes.number,
  };

  render() {
    const { guestRequirements } = this.props.experience;

    return (
      <Container>
        <Title>
          <FormattedMessage {...messages.title} />
        </Title>
        <GroupRulesSummary />

        <TicketsCounter />

        {renderWhenNotNil(() => <Disclaimer>{guestRequirements}</Disclaimer>)(guestRequirements)}

        {renderWhenTrue(() => <PriceSummary price={this.props.totalPrice} />)(this.props.totalPrice > 0)}
      </Container>
    );
  }
}
